
import { defineComponent, reactive, ref } from 'vue';
import route from '@/router';
import store, { MutationTypes } from '@/store';

import { decodeToken } from '@/utils/token';
import { post } from '@/utils/api';
import cookie from '@/utils/cookie';
import Button from '../components/Button.vue';
import InputField from '../components/InputField.vue';
import HeaderLinks from '../components/HeaderLinks.vue';

export default defineComponent({
	components: {
		Button,
		InputField,
		HeaderLinks,
	},

	setup() {
		const inputData = {
			firstName: '',
			lastName: '',
			username: '',
			email: '',
			password: '',
		};

		const state = reactive({
			error: '',
			loading: false,
		});

		const submit = async (event: Event) => {
			event.preventDefault();

			if (inputData.firstName != '' && inputData.lastName != '' && inputData.username != '' && inputData.email != '' && inputData.password != '') {
				state.error = '';

				const timeout = setTimeout(() => {
					state.loading = true;
				}, 1000);
				const data = await post('signup', inputData);
				clearTimeout(timeout);
				state.loading = false;

				if (data.error) {
					state.error = data.message;
					return;
				}

				const decodedToken = decodeToken(data.token);
				cookie.save('token', data.token, decodedToken.expirationDate);

				store.commit(MutationTypes.SET_USERID, data.userID);

				route.push('/home');
				window.location.reload();
			} else {
				state.error = 'Fill in all the fields!';
			}
		};

		return {
			inputData,
			state,

			submit,
		};
	},
});
